import { ui as types } from '@codesass/types';

const config: types.Config = {
  sidebar: [
    {
      path: 'dashboard/*',
      enableLeft: true,
      isLeftShown: true,
    },
  ],
  footer: [
    {
      path: 'dashboard/*',
      shown: false,
    },
  ],
};

export default config;
